import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlane,
  faMountain,
  faMartiniGlass,
  faCar,
} from "@fortawesome/free-solid-svg-icons";
import { renderToStaticMarkup } from "react-dom/server";

// Création d'icône Leaflet à partir de FontAwesome avec couleur et animation
const createFAIcon = (icon, color = "#e4a951") => {
  const svgMarkup = renderToStaticMarkup(
    <FontAwesomeIcon
      icon={icon}
      style={{
        fontSize: "28px",
        color,
        animation: "pulse 1.5s infinite",
        transition: "transform 0.3s",
      }}
    />
  );
  return L.divIcon({
    html: svgMarkup,
    className: "fa-marker-icon",
    iconSize: [40, 40],
    iconAnchor: [20, 40],
  });
};

export default function ZonesMapInteractive() {
  // Markers Côte d'Azur avec infos détaillées
  const markers = [
    {
      position: [43.6284, 7.2159],
      icon: createFAIcon(faPlane, "#0fb1f1ff"), // jaune
      title: "Aéroport Nice",
      details:
        "Transferts rapides et confortables depuis et vers l'Aéroport de Nice.",
    },
    {
      position: [43.8711, 7.3501],
      icon: createFAIcon(faMountain, "#3498db"), // bleu
      title: "Stations de ski",
      details:
        "Accès aux stations de ski : Isola 2000, Auron et autres. Service premium.",
    },
    {
      position: [43.8711, 6.9501],
      icon: createFAIcon(faMountain, "#3498db"), // bleu
      title: "Stations de ski",
      details:
        "Accès aux stations de ski : Isola 2000, Auron et autres. Service premium.",
    },
    {
      position: [43.7384, 7.4246],
      icon: createFAIcon(faMartiniGlass, "#e67e22"), // orange
      title: "Monaco – Casino / Luxe",
      details:
        "Déplacements vers Monaco, casinos et lieux de prestige. Confort et discrétion.",
    },
    {
      position: [43.8102, 7.662],
      icon: createFAIcon(faCar, "#2ecc71"), // vert
      title: "Italie – Déplacements VTC",
      details:
        "Service VTC premium , voyage haut de gamme avec WiFi, café et climatisation.",
    },
    {
      position: [43.5515, 7.0125],
      icon: createFAIcon(faCar, "#9b59b6"), // violet
      title: "Cannes – Excursions et transferts",
      details:
        "Transferts depuis Cannes, visites touristiques et déplacements professionnels.",
    },
    {
      position: [43.4284, 6.6412],
      icon: createFAIcon(faCar, "#e74c3c"), // rouge
      title: "Toulon – Déplacements professionnels",
      details:
        "Service VTC fiable pour vos rendez-vous professionnels et déplacements privés.",
    },
  ];

  return (
    <section className="zones-section py-5 text-center text-white">
      <div
        style={{
          height: "500px",
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
        }}
      >
        <MapContainer
          center={[43.7102, 7.262]} // Nice
          zoom={10}
          scrollWheelZoom={false}
          style={{ height: "100%", width: "100%" }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          />

          {markers.map((m, idx) => (
            <Marker key={idx} position={m.position} icon={m.icon}>
              <Popup>
                <div style={{ textAlign: "center", maxWidth: "200px" }}>
                  <h5 style={{ marginBottom: "5px", color: "#e4a951" }}>
                    {m.title}
                  </h5>
                  <p style={{ fontSize: "0.9rem", margin: 0 }}>{m.details}</p>
                </div>
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
    </section>
  );
}
